<div class="pageHeader">
    <h1 class="pageHeading" style="margin-bottom: 32px; margin-top: 88px; text-align: center;">Abhi Homes <span style=" color: #828282;"> & </span> YourOwnROOM</h1>
    <div class="row " style="padding: 32px 40px">
        
        <div class="col-md-6 col-12 header" >
            
            <div>
                <p class="contentSubText">
                    Prop-tech Company YourOwnROOM signs a $2 Million Partnership with Agser BuildTech Pvt Ltd for their Residential Projects in Bangalore that will have YourOwnROOM as the designated Residential Rental and Property Management partner, responsible for offering end to end PropTech based rental and property management services. 
                    Abhi Homes in Devanahalli, Bangalore, located 10 km from Bangalore International Airport , is the first project to be undertaken by the partnership. It comprises 248 units of residential units. In addition, this partnership will also include Agser Homes – Malur, Bangalore which is located 2.5 KM from Malur Railway Station which comprises of 331 residential units.
                </p>
            </div>
        </div>
        <div class="col-md-6 col-12" style="margin-bottom: 24px;">
            <img src="assets/images/abhihomes.png" class="img-responsive" style="width: 100%;"/>
        </div>
    </div>
</div>

<div class="pageWrapper" style="margin: 64px 0px">
    
    <div class="row" style="padding: 0px 40px"> 
        <div class="col-md-6 col-12">
            <div  id="google_map" >
                <agm-map 
                    [latitude]="latitude" 
                    [longitude]="longitude" 
                    [zoom]="zoom" 
                    style="height: 300px;">
                    <agm-marker 
                        [latitude]="latitude" 
                        [longitude]="longitude">
                    </agm-marker>
                </agm-map>
            </div>
        </div>
        <div class="col-md-6 md-12">
            <div class="detailsContainer">
                <div style="margin-bottom:24px;box-sizing:border-box;">
                    <ul class="nav nav-tabs header-tabs">
                        <li class="nav-item">
                            <p class="nav-link active" id="overview-tab" data-toggle="tab" data-target="#overview" >Project Overview</p>
                        </li>
                        <li class="nav-item">
                            <p class="nav-link" id="amenities-tab" data-toggle="tab" data-target="#amenities">Amenities</p>
                        </li>
                        <!-- <li class="nav-item">
                            <p class="nav-link" id="resources-tab" data-toggle="tab" data-target="#resources">Resources</p>
                        </li> -->
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent">
                    <div class="tab-pane fade show active" id="overview" role="tabpanel" aria-labelledby="overview-tab">
                        <p class="contentText">Abhi Homes in Devanahalli, Bangalore, located 10 km from Bangalore International Airport and 6 KMs from Devanahalli business park phase.</p>
                        <p class="contentText">It is the first project to be undertaken by the partnership.</p>
                        <p class="contentText">It comprises 248 units of 2 bedroom G + 4, sizes 810 to 865 sqft flats.</p>
                        <p class="contentText">Work is underway to hand over these units in May 2024.</p>
                    </div>
                    <div class="tab-pane fade" id="amenities" role="tabpanel" aria-labelledby="amenities-tab">
                        <ul class="amenities">
                            <li>Club house</li>
                            <li>Jogging track</li>
                            <li>Recreational center</li>
                            <li>Yoga room</li>
                            <li>Car wash and charging area</li>
                            <li>Car wash and charging area</li>
                            <li>CCTV surveillance</li>
                            <li>Parks and landscaped area</li>
                            <li>Kids play area</li>
                        </ul>
                    </div>
                    <!-- <div class="tab-pane fade " id="resources" role="tabpanel" aria-labelledby="resources-tab">
                        <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; row-gap: 8px; height: 100%;">
                            <fa-icon [icon]="faFileAlt" style="font-size:40px; color: #828282" ></fa-icon>
                            <a href="../../../assets/files/EXD Five Rings Project Details  (1).pdf" target="_blank" style="cursor: pointer;font-size: 18px; color: #828282; font-family: 'Poppins', sans-serif;">Brochure</a>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <div style="padding: 0px 40px; margin: 88px 0px;">
        <p class="sectionHeader" style="font-weight: 600; margin-top: 8px; margin-bottom: 24px;">Project Plan Gallery</p>
        <div class="imageGallery" style="margin-top: 32px">
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#masterPlanModal">
                <img src="../../../assets/images/abhihomes_plan1.png"  class="projectImages"/>
            </div>
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#planAModal">
                <img src="../../../assets/images/abhihomes_plan2.png"  class="projectImages"/>
            </div>
            <div class="projectImagesWrapper" data-toggle="modal" data-target="#planBModal">
                <img src="../../../assets/images/abhihomes_plan3.png"  class="projectImages"/>
            </div>
        </div>
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        <!-- <div class="col-md-2 col-12">
                <div  style="margin-bottom: 16px; ">
                    <img src="" style="width: 196px; height: 196px;">
                </div>
        </div> -->
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;">
                “Agser Buildtech Pvt Ltd is committed to providing budget value homes to the customer through its two unique projects Abhi homes at Devanahalli Bangalore and Agser Homes at Malur. Bangalore Our partnership with YourOwnROOM will bring in a plethora of opportunities for the clientele who are looking for our apartments purely from investment perspective as YourOwnROOM as a professional rental service provider will be able to fulfill that gap & make it easier. We look forward for a long-lasting relationship with YourOwnROOM.”<br>- R. V. Shiva Reddy, Managing Director.
            </div>
        </div>
        
    </div>
    <div class="row" style="margin: 32px 0px; padding: 0px 40px">
        
        <div class="col-md-10 col-12" style="display: flex; align-items: center; justify-content: center;">
            <div class="memberQuotes" style=" width: 100%;" >
                “The real estate market of Bengaluru is growing exponentially, backed by steady demand and launch of good projects and infrastructure development like BIAL, Metro  expansions, flyovers and SEZ/TechParks, However we continue to see a huge gap between Demand for safe, secure and convenient homes near offices and supply in Bangalore especially for folks in their early career. We are super excited to partner with Agser BuildTech Pvt Ltd and offer our prop-tech rental and property management solutions to the Retail HomeOwners at the Point of Sale. I would also like to thank Mr. Prashanth Srinivas CEO @ Tesseract Management Consulting (TMC) for facilitating this deal. Tighter Partnership with Developers and Propcos is one of our core GTM strategies and will set the momentum for our Growth in 2024-25 and beyond.”<br> - Prabhat Kumar Tiwary, Founder, MD& CEO, YourOwnROOM.
            </div>
        </div>
        <div class="col-md-2 col-12">
            <div  style="margin-bottom: 16px; ">
                <img src="../../../assets/images/prabhat_latest.jpeg" style="width: 196px; height: 196px;">
            </div>
        </div>
    </div>
    
</div>

<div class="modal fade" id="masterPlanModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/abhihomes_plan1.png"  class="projectModalImagesRect"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="planAModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <!-- <p class="contentSubText" style="font-weight: 600;">Type A</p>
                    <p class="contentSubText">Carpet Area: 247 sft | 22.95 sqm</p>
                    <p class="contentSubText">Saleable Area: 370 sft | 34.73 sqm</p> -->
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/abhihomes_plan2.png"  class="projectModalImages"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="planBModal" tabindex="-1" aria-labelledby="devModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <!-- <p class="contentSubText" style="font-weight: 600;">Type B</p>
                    <p class="contentSubText">Carpet Area: 300 sft | 27.87 sqm</p>
                    <p class="contentSubText">Saleable Area: 474 sft | 44.03 sqm</p> -->
                    <div style="display: flex; justify-content: center; align-items: center;">
                        <img src="../../../assets/images/abhihomes_plan3.png"  class="projectModalImages"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



